import React from "react";
import type {VoidFunctionComponent} from "react";

import {useFilterDifficultyCategoryLogic} from "./FilterDifficultyCategory.logic";
import type {Icon} from "../../../components/common/FontIcon";
import {CheckboxListItem} from "../../../components/common/checkbox/CheckboxListItem";
import {FilterDifficultySubcategories} from "../filter-difficulty-subcategories/FilterDifficultySubcategories";

export interface IFilterDifficultyCategoryProps {
  difficultyCategoryId: number;
}

const iconForDifficultyCategory: Record<number, Icon> = {
  2: "icon-difficulty-rookie-compact",
  3: "icon-difficulty-intermediate-compact",
  4: "icon-difficulty-advanced",
};

export const FilterDifficultyCategory: VoidFunctionComponent<IFilterDifficultyCategoryProps> = ({difficultyCategoryId}) => {
  const {title, isSelected, isPartialSelected, handleToggleOnClick} = useFilterDifficultyCategoryLogic(difficultyCategoryId);

  if (iconForDifficultyCategory[difficultyCategoryId] === undefined){
    // shouldn't display
    return null;
  }

  return (
    <CheckboxListItem
      label={`${title}`}
      onClick={handleToggleOnClick}
      isIndeterminate={isPartialSelected}
      isChecked={isSelected}
      icon={iconForDifficultyCategory[difficultyCategoryId]}
    >
      <FilterDifficultySubcategories difficultyCategoryId={difficultyCategoryId} />
    </CheckboxListItem>
  );
}

